import { useState } from "react";
import { Shield } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../../components/ui/accordion";
import CategoryPageShell from "../../../components/workspace/CategoryPageShell";
import { DriveLink } from "../../../components/workspace/HubText";
import { useHashAccordion } from "../../../hooks/useHashAccordion";
import { PAYMENT_ITEMS } from "../../../data/proCarerCircleContent";

export default function PaymentProtection() {
  const [openItem, setOpenItem] = useState("");
  useHashAccordion(PAYMENT_ITEMS.map((i) => i.id), setOpenItem);

  return (
    <CategoryPageShell
      testId="pcc-category-payment-protection"
      slug="payment-protection"
      eyebrow="Payment Protection"
      title="Get paid properly. Avoid disputes."
      description="Clarify who is responsible for payment, prevent unpaid invoices and set expectations clearly before care begins."
    >
      <section className="min-w-0">
        <div className="mb-5 flex items-center gap-2 text-teal">
          <Shield className="w-4 h-4" strokeWidth={2} />
          <span className="text-sm font-semibold uppercase tracking-wide">6 templates & guides</span>
        </div>
        <Accordion type="single" collapsible value={openItem} onValueChange={setOpenItem} className="space-y-3" data-testid="payment-accordion">
          {PAYMENT_ITEMS.map((item) => {
            const Icon = item.icon;
            return (
              <AccordionItem key={item.id} value={item.id} id={item.id} className="rounded-2xl border border-slate-200 bg-white px-5 md:px-7 scroll-mt-24 min-w-0">
                <AccordionTrigger className="py-5 hover:no-underline">
                  <span className="flex items-center gap-3 text-left">
                    <Icon className="w-5 h-5 text-purple shrink-0" strokeWidth={1.75} />
                    <span className="flex flex-col">
                      <span className="font-display text-lg font-semibold">{item.title}</span>
                      <span className="text-sm text-ink-muted font-normal">{item.summary}</span>
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="pb-6 pt-1 text-base leading-relaxed">
                  {item.body}
                  <div className="mt-6 flex flex-wrap gap-3">
                    {item.download && (
                      <DriveLink href={item.download.href} label={item.download.label} variant="download" testId={`payment-dl-${item.id}`} />
                    )}
                    {item.extraDownloads?.map((d, i) => (
                      <DriveLink key={i} href={d.href} label={d.label} variant="download" testId={`payment-dl-extra-${item.id}-${i}`} />
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            );
          })}
        </Accordion>
      </section>
    </CategoryPageShell>
  );
}
